export enum PermissionStatusE {
    PERMISSIONS_GRANTED = 'PERMISSIONS_GRANTED',
    PERMISSIONS_DENIED = 'PERMISSIONS_DENIED', // Permissions denied by browser or system
    WEBCAM_BLOCKED = 'WEBCAM_BLOCKED', // Webcam is blocked by something else
    MIC_ONLY = 'MIC_ONLY', // No webcam at all
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
    QG_BLOCKED = 'QG_BLOCKED', // When QG is missing <all_urls> permission
}
